import { Component, OnInit, Inject } from '@angular/core';
import { Travel } from 'src/app/models/travel';
import { FormGroup, FormBuilder } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { TravelService } from '../../services/travel/travel.service';
import { AddressService } from 'src/app/modules/shared/services/address/address.service';
import { NotifyboxComponent } from 'src/app/modules/shared/components/notifybox/notifybox.component';
import {AIRLINES} from 'src/app/modules/shared/common/api';

@Component({
  selector: 'app-travel-booking-view',
  templateUrl: './travel-booking-view.component.html',
  styleUrls: ['./travel-booking-view.component.scss']
})
export class TravelBookingViewComponent implements OnInit {

  travel: Travel;
  formGroup: FormGroup;
  loading:boolean = false;
  isDraft:boolean;
  fDate: any;
  tDate: any;
  msg: any;
  successMessage: String = '';
  total = 0;
  mealTotal = 0;
  temporaryValue = {};
  transportationOption = ["Airplane","Boat","Bus","Van","Taxi","Jeepney","Tricycle","Habal-Habal"];
  companyOption = AIRLINES;

  dialogConfig:any;
  summaryDetail:any;
  mode:any;

  pipe = new DatePipe('en-US');

  province = [
    {
      origin:'',
    },
    {
      destination: ''
    }
  ];

  city = [
    {
      city:''
    },
    {
      city: ''
    }
  ];

  barangay = [
    {
      barangay:''
    },
    {
      barangay: ''
    }
  ];

  constructor(
    public dialogRef: MatDialogRef<TravelBookingViewComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public travelService: TravelService,
    public addressService: AddressService,
    private formBuilder: FormBuilder,
    public dialog: MatDialog
  ) { }

  ngOnInit() {
    this.travel = new Travel('');
    this.formGroup = this.formBuilder.group({
      travel_authorization_id: ['',null],
      airlines:['',null],
      flight_no:['',null],
      departure_date: ['',null],
      arrival_date:['',null],
      departure_time: ['',null],
      arrival_time:['',null],
      baggage_allowance: ['',null]
    });
    this.travel.formGroup = this.formGroup;

    this.mode = this.data.mode;
    this.fDate = this.data.itinerary_date;
    this.tDate = this.data.itinerary_date;

    let estimatedDeparture = this.pipe.transform(this.data.res.departure_date, 'yyyy-MM-dd');
    let estimatedArrival =  this.pipe.transform(this.data.res.arrival_date, 'yyyy-MM-dd');

    this.formGroup.controls['airlines'].setValue(this.data.res.airlines);
    this.formGroup.controls['flight_no'].setValue(this.data.res.flight_no);
    this.formGroup.controls['departure_date'].setValue(estimatedDeparture);
    this.formGroup.controls['arrival_date'].setValue(estimatedArrival);
    this.formGroup.controls['baggage_allowance'].setValue(this.data.res.baggage_allowance);
    this.formGroup.controls['departure_time'].setValue(this.data.res.departure_time);
    this.formGroup.controls['arrival_time'].setValue(this.data.res.arrival_time);
    this.isDraft = this.data.is_draft;
    if (!this.data.is_draft) {
      this.travel.disableForm();
    }

  }

  
  closeOnClick() {
    this.dialogRef.close('');
  }

  save(){
    let estimatedDeparture = this.pipe.transform(this.formGroup.controls['departure_date'].value, 'yyyy-MM-dd');
    let estimatedArrival =  this.pipe.transform(this.formGroup.controls['arrival_date'].value, 'yyyy-MM-dd');
    this.loading = true;
    if (this.formGroup.valid) {
      this.data.list[this.data.index].airlines = this.formGroup.controls['airlines'].value;
      this.data.list[this.data.index].flight_no = this.formGroup.controls['flight_no'].value;
      this.data.list[this.data.index].departure_date = estimatedDeparture;
      this.data.list[this.data.index].arrival_date = estimatedArrival;
      this.data.list[this.data.index].departure_time = this.formGroup.controls['departure_time'].value;
      this.data.list[this.data.index].arrival_time = this.formGroup.controls['arrival_time'].value;
      this.data.list[this.data.index].baggage_allowance = this.formGroup.controls['baggage_allowance'].value;
      this.loading = false;
      this.dialog.open(NotifyboxComponent, {
        disableClose:true,
        data: {
          reload:false,
          isclose:true,
          label:'Ok',
          message: 'Booking has been updated.'
        }
      }).afterClosed().subscribe(result => {
        if (result) {
          this.dialogRef.close(this.data.list);
        }
      });
    }
    
  }

  close() {
    this.dialogRef.close(this.data.list);
  }

  keypressValidateNumber(e,max) {
    const pattern = new RegExp(/\d/); // '\d'
     return pattern.test(e.key);
  }

  /**
   * Number validation on input fields
   */  
  keypressValidateNumberDecimal(e) {
    const pattern = new RegExp(/^\d*\.?\d{0,2}$/g);
    const rgx = /^[0-9]*\.?[0-9]*$/;
    if ((e.key == '.' && e.target.value.includes('.')) || !pattern.test(e.key)) {
      return false;
    }
    return (e.target.value.match(rgx)) ? true : false;
  }

  Delete(){
    this.data.list.splice(this.data.index, 1);
    if (this.data.mode == 1) {
      this.loading = true;
      this.travelService.deleteBooking(this.data.book_id).subscribe(res=>{
        this.loading = false;
        this.dialogRef.close(this.data.list);
      });
    } else {
      this.dialogRef.close(this.data.list);
    }
  }

  changeCity(id,i){
    this.addressService.getCity(id).subscribe(res=>{
      this.city[i].city = res;
    });
  }

  changeBarangay(id,i){
    this.addressService.getBarangay(id).subscribe(res=>{
      this.barangay[i].barangay = res;
    });
  }

  getProvince(){
    this.addressService.getProvince().subscribe(res=>{
      this.province[0].origin = res;
      this.province[1].destination= res;
    });
  }

  onChangeStartDate(e) {
    this.fDate = this.pipe.transform(e.value, 'yyyy-MM-dd');
  }

  onChangeEndDate(e) {
    this.tDate = this.pipe.transform(e.value, 'yyyy-MM-dd');
  }

}
